import { TrashIcon } from "@heroicons/react/24/outline";

import ButtonNewItem from "~/components/buttons/ButtonNewItem/ButtonNewItem.tsx";
import FormSection from "~/components/formElements/FormSection";
import type { EligibleQuotaInvoice } from "~/modules/quota/api/quota/quotaTypes.ts";
import { QuotaInvoiceSummary } from "~/modules/quota/components/QuotaInvoiceSummary.tsx";

type Props = {
	invoices: EligibleQuotaInvoice[];
	onAddClick: () => void;
	onRemove: (invoiceId: string) => void;
};

// The selected-invoices section for an invoice-backed quota form. The parent form owns
// the selected invoice ids. The section renders each invoice with its excess and a remove control.
export const QuotaInvoicesFormSection = ({ invoices, onAddClick, onRemove }: Props) => {
	return (
		<FormSection title="Rechnungen">
			<div className="space-y-4">
				{invoices.map(invoice => (
					<div key={invoice.id}
						 className="flex items-start gap-x-4 rounded-lg border border-gray-300 p-4">
						<QuotaInvoiceSummary invoice={invoice} />
						<button type="button"
								className="group flex flex-col items-center justify-center"
								onClick={() => onRemove(invoice.id)}>
							<TrashIcon className="size-5 text-danger-500 group-hover:text-danger-700" />
						</button>
					</div>
				))}
				<ButtonNewItem size="sm"
							   theme="inline"
							   onClick={onAddClick}
				>{invoices.length > 0 && "Weitere "}Rechnung/en auswählen</ButtonNewItem>
			</div>
		</FormSection>
	);
};
